import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=1df545b7&scoped=true&"
import script from "./TicketsList.vue?vue&type=script&lang=js&"
export * from "./TicketsList.vue?vue&type=script&lang=js&"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=1df545b7&lang=scss&scoped=true&"
import style1 from "./TicketsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df545b7",
  null
  
)

export default component.exports